<template>
  <div
    v-show="showTableContent"
    class="directory-order-table-components"
  >
    <div
      v-if="!!items"
      class="table-header-bar"
    >
      <div class="header-left-block float-left">
        <label class="title">{{ titleMap[viewType] }}</label>
      </div>
    </div>
    <div class="directory-table-content">
      <table class="directory-order-table">
        <thead>
          <tr>
            <th
              class="tenancyId"
              @click="() => { handleSortHeaderClick('tenancyId') }"
            >
              {{ $t('directory.label.tenancyRecordId') }}
              <i :class="generateSortClass('tenancyId')" />
            </th>
            <th
              class="tenantName"
              @click="() => { handleSortHeaderClick('tenantName') }"
            >
              {{ $t('directory.label.tenantName') }}
              <i :class="generateSortClass('tenantName')" />
            </th>
            <th
              v-for="header in headers"
              :key="header.attr"
              :class="header.cls"
              @click="() => { handleSortHeaderClick(header.attr) }"
            >
              {{ header.title }}
              <i :class="generateSortClass(header.attr)" />
            </th>
            <th
              v-if="isFloor"
              class="premises"
              @click="() => { handleSortHeaderClick('premises') }"
            >
              {{ $t('directory.label.premises') }}
              <i :class="generateSortClass('premises')" />
            </th>
            <th
              class="effective-date"
              @click="() => { handleSortHeaderClick('effectiveDate') }"
            >
              {{ $t('directory.label.effectiveDate') }}
              <i :class="generateSortClass('effectiveDate')" />
            </th>
            <th
              class="status"
              @click="() => { handleSortHeaderClick('status') }"
            >
              {{ $t('directory.label.status') }}
              <i :class="generateSortClass('status')" />
            </th>
            <th
              class="effective-date"
              @click="() => { handleSortHeaderClick('removeDate') }"
            >
              {{ $t('directory.label.removeDate') }}
              <i :class="generateSortClass('removeDate')" />
            </th>
            <th
              class="effective-date"
              @click="() => { handleSortHeaderClick('publishedAt') }"
            >
              {{ $t('directory.label.publishedDate') }}
              <i :class="generateSortClass('publishedAt')" />
            </th>
          </tr>
        </thead>
        <DirectoryArchivedTableRow
          v-for="(row, index) in searchTableRows"
          :key="row.item.id"
          :viewType="viewType"

          :directory="row.item"
          :displayItems="row.displayItems"
          :orderOptions="row.orderOptions"
          :index="index"
          :actionSettings="row.actionSettings"

          :disableAllExceptLinks="false"
          :windowScrollY="windowScrollY"
        />
      </table>
    </div>
    <ActionConfirmModal
      ref="removePublishedConfirmModal"
      :confirmTitle="$t('directory.msg.removePublishedConfirm.title')"
    >
      <div slot="content">
        <div class="confirm-remove-table">
          <CommonTable
            ref="removePublishedConfirmModal"
            :needCache="false"
            :tableContentLists="currentRemoveDirectory"
            :renderHeaderList="confirmRemoveTableHeader"
            :resizeColumnWhenContentChange="false"
            :defaultOrder="false"
            :needFilter="false"
            tableId="confirm-remove-table"
          />
        </div>
        <div class="modal-pure-text">
          {{ $t('directory.msg.removePublishedConfirm.message') }}
        </div>
      </div>
    </ActionConfirmModal>
  </div>
</template>
<script>
import DirectoryOrderTable from './DirectoryOrderTable'
import DirectoryArchivedTableRow from './DirectoryArchivedTableRow'
import {preProcessDirectoriesForArchived, searchCompanyParamsFilterFunc, formatArchivedSearchStatus} from '@/modules/directories/utils'
import { getFloorAndPremisesAtTerminal } from './directoryOrderTableHelper'
import lodash from 'lodash'
import {DIR_STATUS, DIR_TYPE, DIR_ACTION} from '@/modules/directories/consts'

export default {
  name: 'DirectoryArchivedTable',
  components: { DirectoryArchivedTableRow },

  mixins: [ DirectoryOrderTable ],

  data () {
    return {
      orderKey: '',
      asc: true,
      sortFunctions: {
        tenancyId: ({item}) => {
          return item.companies[0].mainCompanyIndex ? '' : item.tenancy.id
        },
        tenantName: ({item}) => {
          return item.tenancy.company.name
        },
        engName: ({item}) => {
          return item.companies[0].engName || ''
        },
        chtName: ({item}) => {
          return item.companies[0].chtName || ''
        },
        floor: ({item}) => {
          return item.floor
        },
        premises: ({item}) => {
          return item.companies[0].premises
        },
        floorAndPremisesAtTerminal: ({item}) => {
          return getFloorAndPremisesAtTerminal(item.companies[0])
        },
        effectiveDate: ({item}) => {
          const date = this.maskDateToDay(item.effectiveDate)
          return date ? date.getTime() : 0
        },
        removeDate: ({item}) => {
          const date = this.maskDateToDay(item.removeDate)
          return date ? date.getTime() : 0
        },
        publishedAt: ({item}) => {
          const date = this.maskDateToDay(item.publishedAt)
          return date ? date.getTime() : 0
        },
        status: ({item}) => {
          return formatArchivedSearchStatus(item.status, item.action)
        },
      },
    }
  },

  computed: {
    searchTableRows () {
      if (!this.orderKey) return this.displayTableRows
      return lodash.orderBy(this.displayTableRows, [
        this.sortFunctions[this.orderKey],
      ], [this.asc ? 'asc' : 'desc'])
    },
  },

  methods: {
    matchFilterFunc (item) {
      return item &&
        !(item.status === DIR_STATUS.SUBMITTED && item.action === DIR_ACTION.ADD) &&
        this.dateFilterFunc(item) &&
        searchCompanyParamsFilterFunc(item, this.searchCompanyParams)
    },
    dateFilterFunc (item) {
      const effectiveDateMatch = !this.filterParams.effectiveDate || this.dayEquals(item.effectiveDate, this.filterParams.effectiveDate)
      const removeDateMatch = !this.filterParams.removeDate || this.dayEquals(item.removeDate, this.filterParams.removeDate)
      const publishedAtMatch = !this.filterParams.publishedAt || this.dayEquals(item.publishedAt, this.filterParams.publishedAt)
      return effectiveDateMatch && removeDateMatch && publishedAtMatch
    },
    maskDateToDay (time) {
      let date = new Date(time)
      if (!time || isNaN(date)) return null
      date.setHours(0, 0, 0, 0)
      return date
    },
    dayEquals (dateOne, dateTwo) {
      if (!dateOne || !dateTwo) return false
      return this.maskDateToDay(dateOne).getTime() === this.maskDateToDay(dateTwo).getTime()
    },
    handleSortHeaderClick (key) {
      if (key === this.orderKey) {
        this.asc = !this.asc
      } else {
        this.asc = true
      }
      this.orderKey = key
    },
    resetSortHeader () {
      this.orderKey = ''
      this.asc = true
    },
    generateSortClass (key) {
      return {
        'triangle-up': this.orderKey === key && this.asc,
        'triangle-down': this.orderKey === key && !this.asc,
      }
    },
    async loadDirectories (searchParams) {
      const directories = await this.loadAll({
        ...searchParams,
        status: [ DIR_STATUS.CART, DIR_STATUS.SUBMITTED, DIR_STATUS.PROCESSED, DIR_STATUS.PUBLISHED ],
      })
      this.originDirectories = directories
      const filteredDirectories = preProcessDirectoriesForArchived(directories, this.itemMap)
      const isFloor = searchParams.type === DIR_TYPE.FLOOR
      this.items = filteredDirectories
      this.items.filter(item => !this.isDuplicate(item)).forEach(item => {
        if (item.child) {
          this.updateChild(item)
        }
      })
      const groups = this.generateItemGroups(filteredDirectories, isFloor)
      this.reassignOrders(groups, isFloor)
      this.itemGroups = groups
      this.itemGroupsSnapshot = this.itemGroups
      this.maintainHistories = await this.listMaintainHistories(searchParams)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/table";
@import "~styles/directories/maintain";
@import '~styles/popup';
@import '~styles/components/hotb-list';

.directory-order-table-components {
  height: fit-content;
  box-shadow: 0 0 4px 0 rgba(172, 172, 172, 0.5);
  background-color: #ffffff;
  margin: 15px;
  .table-header-bar {
    height: 58px;
    width: 100%;
    display: inline-block;
    border-bottom: solid 1px #ebebeb;
    .header-left-block {
      height: inherit;
      align-items: center;
      display: flex;
    }
    .header-right-block {
      height: inherit;
      align-items: center;
      display: flex;
    }
    .title {
      margin: 19px 21px;
      font-family: Verdana;
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: normal;
      color: #10416c;
    }
  }
  .directory-table-content {
    margin: 15px;
    .directory-order-table thead th {
      position: sticky;
      top: -1px;
      box-shadow: 0 1px 1px -1px rgba(0, 0, 0, 0.4);
      z-index: 1;
    }
  }
}

.confirm-remove-table {
  margin-top: 20px;
  margin-bottom: 20px;
  & ::v-deep .table-list {
    width: 100%;
  }
  & ::v-deep .table-content {
    width: 100% !important;
  }
  & ::v-deep .common-table-header-container {
    min-width: 100%;
    max-width: 100%;
  }
  & ::v-deep .common-table {
    min-width: 100%;
    max-width: 100%;
    min-height: unset;
    margin: 0;
    .engName {
      width: 75%;
    }
    .floor, .premises{
      width: 25%;
    }
  }
}
</style>
